import React, { useState } from "react";
import { Form } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import CommonStyles from "../InputFieldsController/InputFieldsController.module.css";
import {
  FieldProps,
  getFieldContainerStyle,
} from "../InputFieldsController/InputFieldsController.utils";
import LabeledInputWrapper from "../InputFieldsController/LabeledInputWrapper";

interface PasswordInputProps {
  field: FieldProps;
  handleChange: (fieldId: string, event: any) => void;
  handleBlur: (fieldId: string) => void;
  handleSelect: (fieldId: string) => void;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  field,
  handleChange,
  handleBlur,
  handleSelect,
}) => {
  const {
    id,
    placeholder,
    value,
    example,
    disabled,
    isValid = true,
    error,
    show = true,
    selected,
  } = field;

  const [showPassword, setShowPassword] = useState(false);

  if (!show) return null;

  const containerStyle = getFieldContainerStyle(field);

  return (
    <div style={containerStyle}>
      <LabeledInputWrapper field={field}>
        <div style={{ position: "relative" }}>
          <Form.Control
            id={id}
            type={showPassword ? "text" : "password"}
            value={value ?? ""}
            placeholder={placeholder}
            disabled={disabled}
            autoComplete="off"
            onChange={(e) => handleChange(id, e)}
            onBlur={() => handleBlur(id)}
            onFocus={() => handleSelect(id)}
            isInvalid={!isValid}
            className={`${CommonStyles.customInput} ${
              selected ? CommonStyles.selectedField : ""
            }`}
          />
          <span
            onClick={() => setShowPassword((prev) => !prev)}
            style={{
              position: "absolute",
              top: "50%",
              right: 10,
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
          >
            {showPassword ? <Icon.EyeSlash /> : <Icon.Eye />}
          </span>
        </div>

        {!isValid && error && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        )}
      </LabeledInputWrapper>

      {example && <small className="text-muted">Example: {example}</small>}
    </div>
  );
};

export default PasswordInput;
